import request from '@/utils/request'

const downloadBlob = function(content, filename) {
  var fileURL = window.URL.createObjectURL(new Blob([content]));
  var fileLink = document.createElement('a');
  fileLink.href = fileURL;
  fileLink.setAttribute('download', filename);
  document.body.appendChild(fileLink);
  fileLink.click();
}

export function exportExcel (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/export/ae/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = request.timeoutrequest;}); //issue 658
}

export function exportExcelPregnancy (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/export/pregnancy/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = request.timeoutrequest;}); //issue 658
}

export function exportExcelSpm (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/export/spm/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = request.timeoutrequest;}); //issue 658
}

export function reportSae (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/sae/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
       'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = 5000;});
}

export function reportSar (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/sar/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
       'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = 5000;});
}

export function report (type, filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/' + type,
    method: 'get',
    responseType: 'blob',
    headers: {
       'X-filters': JSON.stringify(filters),
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = 5000;});
}



export function reportRec (filters) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/rec/' + filters.protocol_id,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = 5000;});
}



export function reportQualityCheck (filters, type) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/qualitycheck/' + filters.protocol_id + '/' + type,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = 5000;});
}

export function reportMMQuery (filters, type) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url: '/report/mmquery/' + filters.protocol_id + '/' + type,
    method: 'get',
    responseType: 'blob',
    headers: {
      'X-filters': JSON.stringify(filters),
      // 'X-pagination': JSON.stringify(pagination)
    }
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = request.timeoutrequest;}); //issue 658
}

